<!-- eslint-disable no-unused-vars -->
<template>
  <div>
    <Header/>
    <Scroll/>
    <div class="hp_productWrap">
      <div class="hp_productMain_contentWrap">
        <!-- hot키워드 -->
        <div class="hp_productMain_contentSidebar hp_MobNonePcBlock">
          <div class="hp_productMain_contentKeywordBox">
            <p class="hp_productMain_contentKeyword_tit">HOT키워드<span>여행</span></p>
            <div class="hp_productMain_contentKeyword_tagBox">
              <p
                v-for="item in statusData.hotKeywordData"
                :key="item.hot_keyword_ID"
              >
                <a :href="`/TravelProduct?travelSearchData=${encodeURIComponent(item.hot_keyword_name)}`">
                  #{{ item.hot_keyword_name }}
                </a>
              </p>
            </div>
          </div>
        </div>

        <div class="hp_reservInfoWrap">
          <div class="hp_reservInfo_TopTit">
            <h3>결제 안내</h3>
          </div>

          <div class="hp_reservInfo_tit">
            <h5>결제에 <span class="blueColor">실패</span>하였습니다.</h5>
            <p>{{this.$route.query.error_msg}}</p>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<!-- eslint-disable camelcase -->
<script>
import Header from '../Section/Header.vue'
import Footer from '../Section/Footer.vue'
import Scroll from '../Section/Scroll.vue'
import { ref } from 'vue'
import {
  get_hot_keyword_top10
} from '../../ETC/Axios.vue'

export default {
  name: 'ReservationMobileFail',
  components: {
    Header,
    Footer,
    Scroll
  },
  setup () {
    return {
      statusData: ref({
        hotKeywordData: []
      })
    }
  },
  mounted () {
    get_hot_keyword_top10().then(result => {
      this.statusData.hotKeywordData = result
    })
  }

}
</script>



// WEBPACK FOOTER //
// src/components/Homepage/Reservation/ReservationMobileFail.vue